module.exports = __webpack_public_path__ + "img/badge-list-thumb-163.8bd0d652.png";